export default __webpack_public_path__ + "static/media/avail-mobile.e49366e6.png";